import React, { useEffect, useState } from "react";
import RatingStars from "../../common/RatingStars";
import GetAvgRating from "../../../utils/avgRating";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Course_Card = ({ course, Height }) => {
  const [avgReviewCount, setAvgReviewCount] = useState(0);

  useEffect(() => {
    const count = GetAvgRating(course.ratingAndReviews);
    setAvgReviewCount(count);
  }, [course]);

  return (
    <>
      <Link to={`/courses/${course._id}`}>
        <div className="rounded-lg bg-card-background bg-cover bg-opacity-50 ">
          <div className="w-full h-full flex flex-col gap-1 p-8 rounded-lg">
            <div className="rounded-lg bg-[#0000004e] overflow-hidden aspect-16/9">
              <motion.img
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.3 }}
                src={course?.thumbnail}
                alt="course thumnail"
                className={`${Height}  w-full  rounded-lg object-contain`}
              />
            </div>
            <div className="flex flex-col gap-2 px-2 py-3  rounded-b-lg">
              <p className="text-xl text-richblack-5">{course?.courseName}</p>
              <p className="text-sm text-richblack-50">
                {course?.instructor?.firstName} {course?.instructor?.lastName}
              </p>
              <div className="flex items-center gap-2">
                <span className="text-[#029665]">{avgReviewCount || 0}</span>
                <RatingStars Review_Count={avgReviewCount} />
                <span className="text-richblack-400">
                  {course?.ratingAndReviews?.length} Ratings
                </span>
              </div>
              <p className="text-xl text-richblack-5">Rs. {course?.price}</p>
            </div>
          </div>
        </div>
      </Link>
    </>
  );
};

export default Course_Card;
